<form #ngF="ngForm" class="k-form-inline" [formGroup]="form" #pForm action="#" style="width: 100%;" (ngSubmit)="onSubmit()">
  <div class="k-form-field">
    <label class="form-label col-3">Description</label>
    <div class="AutosizeTextArea_container">
      <kendo-textarea class="AutosizeTextArea" formControlName="project_label_description" appAutoFocus></kendo-textarea>
      <div *ngIf="project_label_description?.invalid" class="alert alert-danger">
        <div *ngIf="project_label_description?.errors?.['required']">Description is required.</div>
      </div>
    </div>
  </div>

  <div class="d-grid d-md-flex justify-content-md-end">
    <button type="button" class="btn btn-primary me-md-2" type="submit" [disabled]="form.invalid"> Save</button>
    <button type="button" class="btn btn-secondary" (click)="closeWindow()"> Cancel</button>
  </div>

</form>
